<div class="real-time-status-container">
	<div class="rl-current-status">
		<i class="fas online" [class]="v1 ? 'fa-signal' : 'fa-circle'" *ngIf="connectionStatus === signalStatus.ONLINE"
		   cvTooltip [tooltipText]="'Event Notification On'" [tooltipPlacement]="'bottom'">
		</i>
		<i class="fas offline" [class]="v1 ? 'fa-signal-alt-slash' : 'fa-circle'" *ngIf="connectionStatus === signalStatus.OFFLINE"
		   cvTooltip [tooltipText]="'Event Notification Offline. Reconnecting...'" [tooltipPlacement]="'bottom'">
		</i>
	</div>
</div>
